module.exports = __webpack_public_path__ + "img/quest_icon_0041_cross.1ea88cf4.png";